import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {AttributeManipulationGroupsApiService} from '../../../services/api/settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {AcDialogService} from 'ac-infra';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {NormalizationGroupsDialogComponent} from './normalization-groups-dialog/normalization-groups-dialog.component';
import _ from 'lodash';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';

@Component({
  selector: 'normalization-groups',
  templateUrl: './normalization-groups.component.html',
  styleUrls: ['./normalization-groups.component.scss']
})
export class NormalizationGroupsComponent implements OnInit {

  @ViewChild(ArmTableComponent) armTable;

  isUnauthorized: boolean;
  selection: any;
  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'groupName', display: 'Name', selected: true,  width: 300},
  ];

  filter;
  items: any;

  constructor(private userPrivilege: UserPrivilegeService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.NORMALIZATION_GROUP);
    this.refresh();
  }

  addItem(): void {
    const dialogData = {
      data: {normalizationAttrs: [], groupName: ''},
      isEditMode: false,
      isUnauthorized: this.isUnauthorized
    };

    this.acDialogService.open(NormalizationGroupsDialogComponent, {
      dialogData,
      title: 'Add normalization group',
      onSubmit: () => {
        return this.attributeManipulationGroupsApiService.addAttributeManipulationGroup(dialogData.data)
          .toPromise().then(() => {
            this.refresh();
            this.snackBarService.display(`${dialogData.data.groupName} successfully added`);
          });
      }
    });
  }

  refresh(): void {
    this.loaderService.showMainContainer();
    this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().subscribe(data => {
      this.items = data;
      this.loaderService.hideMainContainer();
    });
  }

  editItem(): void {
    const dialogData = {
      data: _.cloneDeep(this.selection),
      isEditMode: true,
      isUnauthorized: this.isUnauthorized
    };

    this.acDialogService.open(NormalizationGroupsDialogComponent, {
      dialogData,
      title: 'Edit normalization group',
      onSubmit: this.isUnauthorized ? null : () => {
        return this.attributeManipulationGroupsApiService.editAttributeManipulationGroup(dialogData.data, dialogData.data.id)
          .toPromise().then(() => {
            this.refresh();
            this.snackBarService.display(`${this.selection.groupName} successfully updated`);
          });
      }
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the normalization group: "${this.selection.groupName}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.attributeManipulationGroupsApiService.deleteAttributeManipulationGroup(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.groupName} successfully deleted`);
      }, () => {
      });
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  onFilter(filter: any): any {
    this.armTable.firstPage();
    this.filter = filter;
  }
}
